// extracted by mini-css-extract-plugin
export default {"tableRow":"zone_tableRow__VaG0Z","tableCell":"zone_tableCell__7z6iL"};